exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tooltip__content span {\n  text-align: left;\n  display: block;\n  width: 100%;\n}\n.combined-patient-dialog-button {\n  margin: 0 !important;\n  width: 16px !important;\n  height: 16px !important;\n}", ""]);

// exports
